module.exports = __webpack_public_path__ + "static/img/nb.708d525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nb.png
// module id = F1OO
// module chunks = 1